import { render, staticRenderFns } from "./NoDataMessage.vue?vue&type=template&id=3565f377"
import script from "./NoDataMessage.vue?vue&type=script&lang=js"
export * from "./NoDataMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports